import { Component, OnInit } from '@angular/core';
import { Report } from '../../report';
import { ReferralService } from './referrals.service';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss']
})

export class ReferralsComponent implements OnInit {
  tableColumns: string[] = [
    'shop_name',
    'email',
    'username',
    'num_referred',
    'success'
  ];

  displayTableColumns = {
    shop_name: 'Business Name',
    email: 'Email',
    username: 'Business owner',
    num_referred: 'num of people referred',
    success: 'Successful referred'
  };

  totalNumberOfRecords = 0;
  referalReportData: any[] = [];

  constructor(
    public referralReport: ReferralService
  ) { }

  requestBody: Report = {};
  loading = false;

  ngOnInit(): void{
    this.referralReport.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async filter(event: any) {
    //console.log('object is', event);
    if (event && Object.keys(event).length) {
      console.log('filter should not be null');
      this.requestBody.filterOptions = event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.referralReport.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.referralReport.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.referralReport.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }


  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.referralReport.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.referralReport.activateLoader();
    this.referralReport.setParams(this.requestBody);
    const report = await this.referralReport.make();
    this.referalReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }
}
